import { baseApi } from "./baseApi";

// BrandModels API
export const brandModelApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getBrandModels: builder.query({
      query: (params) => {
        let url = "brand_models";

        url += "?";

        if (params.all_pages) {
          url += `all_pages=${params.all_pages}&`;
        }

        if (params.page) {
          url += `page=${params.page}&`;
        }
        if (params.include_all) {
          url += `include_all=${params.include_all}&`;
        }
        if (params.name) {
          url += `name=${params.name}&`;
        }
        if (params.code) {
          url += `code=${params.code}&`;
        }
        if (params.brand_id) {
          url += `brand_id=${params.brand_id}&`;
        }

        // Remove the trailing '&' if any
        if (url.endsWith("&")) {
          url = url.slice(0, -1);
        }

        // Remove the trailing '?' if any
        if (url.endsWith("?")) {
          url = url.slice(0, -1);
        }
        return url;
      }
    }),
    getBrandModel: builder.query({
      query: (id) => `brand_models/${id}`
    }),
    createPricing: builder.mutation({
      query: (params) => ({
        url: `brand_models/${params.brandModelId}/pricings`,
        method: "POST",
        body: params.pricingData
      })
    }),
    updatePricing: builder.mutation({
      query: (params) => ({
        url: `brand_models/${params.brandModelId}/pricings/${params.id}`,
        method: "PUT",
        body: params.pricingData
      })
    }),
    DeletePricing: builder.mutation({
      query: (params) => ({
        url: `brand_models/${params.modelId}/pricings/${params.pricingId}`,
        method: "DELETE"
      })
    })
  })
});

// Export mutations and queries
export const {
  useGetBrandModelsQuery,
  useLazyGetBrandModelsQuery,
  useGetBrandModelQuery,
  useCreatePricingMutation,
  useUpdatePricingMutation,
  useDeletePricingMutation
} = brandModelApi;
